import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import { HttpRequest } from "../../utils/httpRequests";
import ck_logo_login from "../../assets/images/ck_logo_login.png";
import exergysystems_logo_login from "../../assets/images/exergysystems_logo_login.png";

const CssTextField = withStyles({
  root: {
    "& .MuiOutlinedInput-root": {
      fontSize: "20px !important",
      "& fieldset": {
        border: "none !important",
        fontSize: "20px !important",
      },
    },
  },
})(TextField);

const styles = {
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // marginTop: "10%",
    marginTop: 20,
    flexDirection: "column",
    borderRadius: "21px !important",
  },
  input: {
    // width: '400px',
    margin: "10px 0px",
    height: "54px",
    backgroundColor: "#F3F5F5",
    borderColor: "red",
    borderRadius: "20px",
    borderBottom: "none",
    fontSize: "18px",
    textAlign: "center",
  },
  button: {
    margin: "20px 0px 20px 225px",
  },
  checkboxLabel: {
    borderBottom: "1px solid #dcdcdc",
    minWidth: "200px",
    display: "flex",
    justifyContent: "center",
    // marginTop: "-10px",
    marginLeft: "-6px",
    inlineSize: "auto",
  },
  customError: {
    color: "#f44336",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: "0.8rem",
    fontWeight: 400,
    lineHeight: "1.66",
    letterSpacing: "0.03333em",
    marginTop: 5,
  },
  customButton: {
    backgroundColor: "#4F92C9",
    color: "white",
    "&:hover": {
      backgroundColor: "#60a7e0",
    },
    // width: "400px",
    width: "100%",
    margin: "10px 0px",
    height: "54px",
    borderRadius: "20px",
    fontSize: "initial",
  },
  underline: {
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
};

const Login = (props) => {
  const { classes } = props;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userIdError, setUserIdError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [responseError, setresponseError] = useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const height = 54;

  const isValid = () => {
    const userIdErrorMsg = !username ? "Please Enter Valid User ID." : "";
    const passwordErrorMsg = !password ? "Please Enter Password." : "";
    setUserIdError(userIdErrorMsg);
    setPasswordError(passwordErrorMsg);
    return username && password;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    setresponseError("");
    if (isValid()) {
      setIsLoading(true);
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/authentication/C01Authenticate`,
        data,
        ""
      );

      if (res.isSuccess) {
        localStorage.setItem("ckAdminUser", JSON.stringify(res.data));

        window.location.replace("#/sales-order");
      } else {
        setresponseError(res.message);
        setIsLoading(false);
      }
    }
  };

  let currentHeight = window.screen.height * 0.1;
  // eslint-disable-next-line no-unused-vars
  let currentWidth = window.screen.width * 0.1;
  let exlogoMarginRight = window.screen.width * 0.06;
  let cklogoMarginLeft = window.screen.width * 0.06;

  console.log(currentHeight, currentHeight);

  return (
    <Fragment>
      {/* <NavBar hideTitle/> */}
      <form onSubmit={handleSubmit} noValidate>
        <div
          style={{
            height: window.screen.height * 0.75,
          }}
          className={classes.root}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={4}>
              <div
                style={{
                  float: "right",
                  marginRight: exlogoMarginRight,
                }}
              >
                <img
                  alt="img"
                  style={{ height: 139, width: 139 }}
                  src={exergysystems_logo_login}
                />
              </div>
            </Grid>
            <Grid
              justifyContent="center"
              alignItems="center"
              item
              xs={12}
              sm={3}
            >
              <Typography
                color="primary"
                style={{ textAlign: "center", color: "#4F92C9" }}
                variant="h3"
              >
                <b>Employee Portal</b>
              </Typography>

              <br />
              <br />
              <br />

              <CssTextField
                id="id"
                name="Id"
                className={classes.input}
                variant="outlined"
                fullWidth
                placeholder="Employee ID"
                value={username}
                type="number"
                error={!!userIdError}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setUserIdError("");
                }}
                inputProps={{
                  style: {
                    height,
                    padding: "0 14px",
                    borderRadius: "20px",
                    borderWidth: 1,
                    borderBottom: "none",
                    fontSize: "18px",
                  },
                }}
              />

              <CssTextField
                id="password"
                fullWidth
                name="password"
                variant="outlined"
                className={classes.input}
                placeholder="Password"
                autoComplete="false"
                value={password}
                type="password"
                error={!!passwordError}
                inputProps={{
                  style: {
                    height,
                    padding: "0 14px",
                    borderRadius: "20px",
                    borderWidth: 1,
                    borderBottom: "none",
                    fontSize: "20px",
                  },
                }}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError("");
                }}
              />

              {/* <input type="file" name="userCredientialFile" /> 
              <span className={classes.customError}>{responseError}</span> */}

              <Button
                className={classes.customButton}
                variant="contained"
                type="submit"
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Login"
                )}
              </Button>

              <FormControlLabel
                control={
                  <Checkbox
                    value="checkedB"
                    color="primary"
                    style={{ marginLeft: "-7px" }}
                  />
                }
                className={classes.checkboxLabel}
                label="Remember me"
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Link href="#">
                  <Button
                    color="primary"
                    variant="text"
                    style={{ textTransform: "none" }}
                  >
                    Forgot ID or Password?
                  </Button>
                </Link>
              </div>
            </Grid>
            <Grid item xs={12} sm={4}>
              <div
                style={{
                  marginLeft: cklogoMarginLeft,
                }}
              >
                <img
                  alt="img"
                  style={{ width: 139, height: 139 }}
                  src={ck_logo_login}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </form>
    </Fragment>
  );
};

Login.propTypes = {
  classes: PropTypes.any.isRequired,
};

export default withStyles(styles)(Login);
